export const sortAsc = (a, b) => a - b;
export const sortDesc = (a, b) => b - a;
export function flatMap(arr, mapper) {
    return arr.reduce((acc, val, i) => {
        acc.push(...mapper(val, i, arr));
        return acc;
    }, []);
}
